import { render, staticRenderFns } from "./VideoPlayer.vue?vue&type=template&id=19c31e04&scoped=true"
import script from "./VideoPlayer.vue?vue&type=script&lang=js"
export * from "./VideoPlayer.vue?vue&type=script&lang=js"
import style0 from "./VideoPlayer.vue?vue&type=style&index=0&id=19c31e04&prod&lang=scss&scoped=true"
import style1 from "./VideoPlayer.vue?vue&type=style&index=1&id=19c31e04&prod&lang=css"
import style2 from "./VideoPlayer.vue?vue&type=style&index=2&id=19c31e04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c31e04",
  null
  
)

export default component.exports